/** Opt-in for Faro on production when {@link FARO_PROD_COOKIE_NAME} is set to this value. */
export const FARO_PROD_COOKIE_VALUE = 'true';

/** Cookie name; must match edge/nginx Set-Cookie naming. */
export const FARO_PROD_COOKIE_NAME = 'x-mc-faro-enabled';

/**
 * True when the production opt-in cookie is present (browser only).
 * Production Faro is gated on this (nginx sets x-mc-faro-enabled per region).
 */
export function isMcFaroProdCookieEnabled(): boolean {
  if (typeof document === 'undefined' || !document.cookie) {
    return false;
  }
  for (const part of document.cookie.split(';')) {
    const eq = part.indexOf('=');
    const name = (eq === -1 ? part : part.slice(0, eq)).trim();
    const value = eq === -1 ? '' : part.slice(eq + 1).trim();
    if (name === FARO_PROD_COOKIE_NAME && value === FARO_PROD_COOKIE_VALUE) {
      return true;
    }
  }
  return false;
}
